import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { BackofficeUser } from 'src/types/backoffice-user';

type States = {
  me: BackofficeUser | null;
};

type Actions = {
  setMe: (user: BackofficeUser | null) => void;
  setMeFromLogin: (user: BackofficeUser | undefined) => void;
  clearMe: () => void;
};

type MeStore = States & Actions;

const initialState: States = {
  me: null,
};

export const useMeStore = create<MeStore>()(
  persist(
    (set) => ({
      ...initialState,

      setMe: (user) => set({ me: user }),

      setMeFromLogin: (user) => {
        if (user) {
          set({ me: user });
        }
      },

      clearMe: () => set({ me: null }),
    }),
    {
      name: 'me-backoffice-storage',
      partialize: (state) => ({ me: state.me }),
    }
  )
);
